import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import logo from '../../assets/images/logo-white.svg';
import { BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grid1: [
                { title: 'AWS Partnership', link: '/aws-partnership' },
                { title: 'Blog', link: '/blog' },
                { title: 'Contact Us', link: '/contact-us' },
            ],
            grid2: [
                { title: 'Terms of Services', link: '/page-terms' },
                { title: 'Privacy Policy', link: '/page-privacy' },
                { title: 'Cookie Policy', link: '/cookie-policy-more' },
                { title: 'Documentation', link: '/knowledge' },
            ],
            grid3: [
                { title: 'Case studies', link: '/case-studies' },
                { title: 'Webinars', link: '/webinars' },
                { title: 'Press Releases', link: '/press-release' },
            ],
        };
    }

    render() {
        return (
            <footer
                className={
                    this.props.isLight
                        ? 'footer bg-light'
                        : 'footer footer-border'
                }
            >
                <Container>
                    <Row>
                        <Col
                            lg="3"
                            span="12"
                            xs="12"
                            className="mb-0 mb-md-4 pb-0 mr-5 pb-md-2 mb-3  justify-content-center"
                            name="footercolumn"
                        >
                            <div className="logo-footer">
                                <img
                                    src={logo}
                                    height={38}
                                    width={160}
                                    alt="Wendu - Cloud Security and Cost"
                                />
                            </div>
                            <div className="footer-contact mr-md-2">
                                <p>
                                    Headquarters: London 124 City Rd, London
                                    EC1V 2NX London, United Kingdom.
                                </p>
                                <p>
                                    Lagos: 15 Ihuntayi Rd, Oniru Rd, Victoria
                                    Island 101001,Lagos, Nigeria.
                                </p>

                                <p>
                                    Abuja: First Floor, Nigerian Merit Award
                                    House, 22 Aguyi Ironsi Street, Maitama,
                                    Abuja
                                </p>
                            </div>
                            <div className="footer__social-links d-flex gap-3">
                                <a href="https://www.linkedin.com/company/cloudplexo/mycompany">
                                    <BsLinkedin
                                        color="white"
                                        size={24}
                                    />
                                </a>
                                <a href="https://www.instagram.com/cloudplexo/">
                                    <BsInstagram
                                        color="white"
                                        size={24}
                                    />
                                </a>
                                <a href="https://web.facebook.com/CloudplexoCMP">
                                    <BsFacebook
                                        color="white"
                                        size={24}
                                    />
                                </a>
                            </div>
                        </Col>

                        <Col
                            lg={3}
                            md={4}
                            className="mb-4"
                            name="footercolumn"
                        >
                            <div>
                                <h5
                                    className={
                                        this.props.isLight
                                            ? 'text-dark footer-head '
                                            : 'text-light footer-head '
                                    }
                                >
                                    Company
                                </h5>
                                <ul className="list-unstyled footer-list mt-2">
                                    {this.state.grid1.map((grid, key) => (
                                        <li key={key}>
                                            <Link
                                                to={grid.link}
                                                className={
                                                    this.props.isLight
                                                        ? 'text-muted'
                                                        : 'text-foot'
                                                }
                                            >
                                                {grid.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col
                            lg={3}
                            className="mb-4"
                            md={4}
                        >
                            <div>
                                <h5
                                    className={
                                        this.props.isLight
                                            ? 'text-dark footer-head'
                                            : 'text-light footer-head'
                                    }
                                >
                                    Useful Links
                                </h5>
                                <ul className="list-unstyled footer-list mt-2">
                                    {this.state.grid2.map((grid, key) => (
                                        <li key={key}>
                                            <Link
                                                to={grid.link}
                                                className={
                                                    this.props.isLight
                                                        ? 'text-muted'
                                                        : 'text-foot'
                                                }
                                            >
                                                {grid.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col
                            lg={3}
                            className="mb-4"
                            md={4}
                        >
                            <div>
                                <h5
                                    className={
                                        this.props.isLight
                                            ? 'text-dark footer-head'
                                            : 'text-light footer-head'
                                    }
                                >
                                    Resources
                                </h5>
                                <ul className="list-unstyled footer-list mt-2">
                                    {this.state.grid3.map((grid, key) => (
                                        <li key={key}>
                                            <a
                                                href={grid.link}
                                                className={
                                                    this.props.isLight
                                                        ? 'text-muted'
                                                        : 'text-foot'
                                                }
                                            >
                                                {grid.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        );
    }
}

export default Footer;
